import { DateTime } from 'luxon';
import React from 'react';

// import { api } from '@/utils/api';
import { Button } from '~/components/Button/Button';
import { useCallContext } from '~/components/Dialer/call.context';
import { FieldError } from '~/components/ErrorMessage/ErrorMessage';
import styles from './CallNotes.module.scss';
import { Textarea } from '@poseidon/components/Input';

const liveAnswerDispo = 'Live Answer';
const dialingDispos = [
  liveAnswerDispo,
  'Voicemail',
  'Gate Keeper',
  'Busy Signal',
  'No Answer',
  'Bad Number',
  'Do not call',
];

const onCallDispos = [
  'Activated lead - Follow Up Required',
  'Activated lead - Meeting Scheduled',
  'Quick Hang Up',
  'Not Interested',
  'Gatekeeper/Target Not Reached',
  'Wrong Person',
  'Referral',
  'Do Not Call',
];

const CallNotes = () => {
  const [{ callStarted, error }] = useCallContext();
  const [notes, setNotes] = React.useState('');
  const [liveAnswer, setLiveAnswer] = React.useState(false);

  // const updateMutation = api.history.updateCallNotes.useMutation({
  //   onSuccess: async () => {
  //   },
  // });

  React.useEffect(() => {
    if (callStarted) {
      setLiveAnswer(false);
    }
  }, [callStarted]);

  const handleClickDispo = (dispo: string) => {
    const dateLuxon = DateTime.now();
    const dateTime = dateLuxon.toFormat('h:mm a');

    setNotes((notes) => {
      const prevNotes = notes.trim();
      const newLine = (prevNotes.length > 0 ? '\n' : '') + dateTime + '  ' + dispo;
      return notes + newLine;
    });

    if (dispo === liveAnswerDispo) {
      setLiveAnswer(true);
    }
  };

  // const handleOnClickUpdate = async () => {
  //   if (callSid == null) return;
  // await updateMutation
  //   .mutateAsync({
  //     callSid,
  //     notes,
  //   })
  //   .then(() => {
  //     // if person is in a call, don't close the dialer
  //     if (!callOpen) {
  //       hideDialer();
  //     }
  //   })
  //   .catch(() => {
  //     // noop
  //   });
  // };

  return (
    <div className={styles.container}>
      {!liveAnswer && (
        <div className={styles.dispos}>
          {dialingDispos.map((dispo) => {
            return (
              <Button key={dispo} size="small" onClick={() => handleClickDispo(dispo)}>
                {dispo}
              </Button>
            );
          })}
        </div>
      )}

      {liveAnswer && (
        <div className={styles.dispos}>
          {onCallDispos.map((dispo) => {
            return (
              <Button key={dispo} size="small" onClick={() => handleClickDispo(dispo)}>
                {dispo}
              </Button>
            );
          })}
        </div>
      )}

      <Textarea
        className={styles.callNotes}
        title="Call notes"
        placeholder="call notes"
        value={notes}
        onChange={(e) => {
          setNotes(e.target.value);
        }}
      />
      {/* <FieldError>{updateMutation?.error?.message}</FieldError> */}
      <FieldError>{error}</FieldError>

      {/* <div className="flex justify-end">
        <SubmitButton loading={updateMutation.isPending} onClick={handleOnClickUpdate}>
          Save notes
        </SubmitButton>
      </div> */}
    </div>
  );
};

export default CallNotes;
